export enum UserDefinitionTextFilterKinds {
  /** 部分一致 */
  Contains,
  /** 前方一致 */
  StartsWith,
}
